<template>
  <div id="public_project">
    <div class="project-box">
      <div class="project-top">
        <span></span>
        <div class="top-l">
          <p>PROJECT</p>
          <h3>推荐项目</h3>
        </div>
        <div class="top-r">
          <i></i>
        </div>
      </div>
      <div class="project-bottom">
        <ul>
          <li v-for="(item,index) in projectList" :key="index">
            <i>
              <img src="../../assets/images/news.png" alt>
            </i>
            <h5>{{item.title}}</h5>
            <p>资助人次 : {{item.num}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      projectList: [
        {
          i: 1,
          num: "28,842",
          title: "顺丰莲花小学"
        },
        {
          i: 1,
          num: "28,842",
          title: "儿童医疗救助"
        },
        {
          i: 1,
          num: "28,842",
          title: "顺丰爱心电教室"
        },
        {
          i: 1,
          num: "28,842",
          title: "凉山爱心班"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#public_project {
  width: 100%;
}
.project-box {
  margin-top: 10px;
  .project-top {
    position: relative;
    padding-left: 18px;
    display: flex;
    justify-content: space-between;
    text-align: left;
    > span {
      width: 2px;
      // height: 55px;
      height: 100%;
      background-image: linear-gradient(
          0deg,
          #8ec31f 0%,
          #4eb875 10%,
          #2dbadc 20%,
          #258bcc 31%,
          #273d96 43%,
          #944496 50%,
          #bb4695 53%,
          #dc0536 65%,
          #e83a16 76%,
          #fcd475 89%,
          #d7de00 100%
        ),
        linear-gradient(#c12411, #c12411);
      position: absolute;
      left: 0;
      top: 0;
    }
    .top-l {
      > p {
        font-size: 18px;
        font-weight: normal;
        color: #ccc;
      }
      > h3 {
        font-size: 18px;
        font-weight: 500;
        color: #333;
      }
    }
    .top-r {
      padding-right: 25px;
      position: relative;
      // width: 308px;
      > i {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: url(../../assets/images/more.png) no-repeat;
        background-size: 100% 100%;
        &:hover {
          background: url(../../assets/images/more1.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .project-bottom {
    padding: 30px 0;
    > ul {
      > li {
        list-style: none;
        margin-bottom: 16px;
        font-size: 16px;
        color: #333;
        padding: 21px 0;
        padding-left: 150px;
        position: relative;
        text-align: left;
        cursor: pointer;
        &:hover {
          > h5 {
            color: #e83a16;
          }
          > p {
            color: #e83a16;
          }
        }
        > i {
          width: 130px;
          height: 90px;
          position: absolute;
          top: 0;
          left: 0;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        > h5 {
          font-size: 16px;
          font-weight: normal;
          color: #333333;
          margin-bottom: 7px;
          overflow: hidden; /* 超出部分隐藏 */
          white-space: nowrap;
          /* 不换行 */
          text-overflow: ellipsis; /* 超出部分省略号显示 */
        }
        > p {
          font-size: 15px;
          color: #999;
          text-align: left;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recommend/project.vue